import axios from 'axios';
import { signOut } from './auth';
import currentSession from './currentSession';

// Create an Axios instance
const axiosInstance = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request only. There is no response interceptor, so a 401 reaches the caller
// as a failed request rather than triggering a refresh-and-retry.
axiosInstance.interceptors.request.use(
  async (config) => {
    const { email, jwtToken } = await currentSession();
    const url = new URL(config.url!, window.location.origin);
    url.searchParams.set('email', email);
    const newConfig = { ...config, url: url.toString() };
    if (email && jwtToken && email !== '' && jwtToken !== '') {
      newConfig.headers.email = email;
      newConfig.headers.Authorization = `Bearer ${jwtToken}`;
    } else {
      await signOut();
      window.location.reload();
    }
    return newConfig;
  },
  (error) =>
    // Handle request errors
    Promise.reject(error),
);

export default axiosInstance;
